module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Action Name"
    },
    model: {
      value: (_vm.action.name),
      callback: function($$v) {
        _vm.$set(_vm.action, "name", $$v)
      },
      expression: "action.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field"
    },
    model: {
      value: (_vm.action.field),
      callback: function($$v) {
        _vm.$set(_vm.action, "field", $$v)
      },
      expression: "action.field"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.actionTypes,
      "item-text": "name",
      "item-value": "name",
      "label": "Action Type"
    },
    model: {
      value: (_vm.action.type),
      callback: function($$v) {
        _vm.$set(_vm.action, "type", $$v)
      },
      expression: "action.type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Expression"
    },
    model: {
      value: (_vm.action.expression),
      callback: function($$v) {
        _vm.$set(_vm.action, "expression", $$v)
      },
      expression: "action.expression"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "label": "Create"
    },
    model: {
      value: (_vm.action.operationCreate),
      callback: function($$v) {
        _vm.$set(_vm.action, "operationCreate", $$v)
      },
      expression: "action.operationCreate"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "label": "Update"
    },
    model: {
      value: (_vm.action.operationUpdate),
      callback: function($$v) {
        _vm.$set(_vm.action, "operationUpdate", $$v)
      },
      expression: "action.operationUpdate"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "label": "Delete"
    },
    model: {
      value: (_vm.action.operationDelete),
      callback: function($$v) {
        _vm.$set(_vm.action, "operationDelete", $$v)
      },
      expression: "action.operationDelete"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.action._id) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f90fee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/system/ActionDialog.vue
// module id = 2501
// module chunks = 1